"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.determineIfShowIsOnNow = exports.create2WeeksList = void 0;
var _add = _interopRequireDefault(require("date-fns/add"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
/**
 * creates an array containing dates for 2 weeks
 * starting from todays date
 * 
 * dates have four attributes: 
 *      dayStr (string format EEE) 
 *      dateStr (string format MMM d)
 *      scheduleDateStr (string format y-MM-dd)
 *      date (js date time)
 * 
 * @returns (array) weeks
 */
const create2WeeksList = () => {
  // make sure dates are relative to EST
  const estDateString = new Date().toLocaleString('en-US', {
    timeZone: "America/New_York"
  });
  const estDate = new Date(estDateString);

  // the broadcast day starts @ 6am EST so if the time is less then 6am
  // "today" is still yesterday according to our schedule
  const today = Number.parseInt((0, _format.default)(estDate, 'H'), 10) < 6 ? (0, _sub.default)(estDate, {
    days: 1
  }) : estDate;
  let weeks = [[], []];
  for (let i = 0; i <= 13; ++i) {
    const newDay = (0, _add.default)(today, {
      days: i
    });
    const j = i <= 6 ? 0 : 1;
    weeks[j].push({
      dayStr: i === 0 ? "Today" : (0, _format.default)(newDay, "EEE"),
      monthStr: (0, _format.default)(newDay, "MMM"),
      dateStr: (0, _format.default)(newDay, 'd'),
      fullDateStr: (0, _format.default)(newDay, "yyyy-MM-dd"),
      date: newDay
    });
  }
  return weeks;
};

/**
 * Checks the current time against the airdate and length of a show
 * to determine if the show is currently on the air
 * 
 * @param {string} airdateStr - needs to be parseable by Date() method
 * @param {string} elementLength - format H:MM
 * @returns {boolean}
 */
exports.create2WeeksList = create2WeeksList;
const determineIfShowIsOnNow = (airdateStr, elementLength) => {
  // make sure dates are relative to EST
  const estDateString = new Date().toLocaleString('en-US', {
    timeZone: "America/New_York"
  });
  const now = new Date(estDateString);
  const estAirdateStr = new Date(airdateStr.replace(' ', 'T')).toLocaleString('en-US', {
    timeZone: "America/New_York"
  });
  const airdate = new Date(estAirdateStr);
  // airdate strings from the schedule that start after midnight and before 6am
  // have the wrong date to compare with, so switch them to the correct date (the next day)
  const compareToDate = Number.parseInt((0, _format.default)(airdate, 'H')) < 6 ? (0, _add.default)(airdate, {
    days: 1
  }) : airdate;
  const [hours, mins] = elementLength.split(':');
  const minutes = parseInt(hours, 10) * 60 + parseInt(mins);
  return now >= compareToDate && now <= (0, _add.default)(compareToDate, {
    minutes
  });
};
exports.determineIfShowIsOnNow = determineIfShowIsOnNow;